/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ perPortion: NonNullable<unknown>, total: NonNullable<unknown> }} Cost_Tooltip_TitleInputs */

const en_cost_tooltip_title = /** @type {(inputs: Cost_Tooltip_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.perPortion} per portion · ${i?.total} total`)
};

const de_cost_tooltip_title = /** @type {(inputs: Cost_Tooltip_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.perPortion} pro Portion · ${i?.total} gesamt`)
};

/**
* | output |
* | --- |
* | "≈ {perPortion} per portion · {total} total" |
*
* @param {Cost_Tooltip_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_tooltip_title = /** @type {((inputs: Cost_Tooltip_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Tooltip_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cost_tooltip_title(inputs)
	return en_cost_tooltip_title(inputs)
});